import ActionsForm from '@/shared/mixins/actionsForm'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm, ExpenseMixin],
  name: 'Searchsalesbyaccredited',
  components: {
    AutocompleteZ
  },
  data () {
    return {
      title: 'Buscar Relatório',
      dataEnteprise: null,
      entepriseid: '',
      onlyTable: false,
      typeSearch: '',
      formsearch: {
        nome: '',
        empreendimentoId: '',
        DtInicial: '',
        DtFinal: '',
        ImobiliariaId: '',
        imobiliaria: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      showDate: false

    }
  },
  mounted () {
    this.getAllEnteprise()
  },
  methods: {
    filter (obj) {
      this.typeSearch = obj.target.id
      if (obj.target.id === 'semanal') {
        const now = new Date()
        var diferencaPSegunda = now.getDay() - 1
        var diferencaPSexta = (5 - now.getDay())
        const monday = new Date()
        monday.setDate(now.getDate() - diferencaPSegunda)

        const friday = new Date()
        friday.setDate(now.getDate() + diferencaPSexta)

        this.formsearch.DtInicial = monday
        this.formsearch.DtFinal = friday
        this.showDate = false
      }

      if (obj.target.id === 'mensal') {
        const now = new Date()
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

        this.formsearch.DtFinal = lastDay
        this.formsearch.DtInicial = firstDay
        this.showDate = false
      }

      if (obj.target.id === 'anual') {
        const now = new Date()
        const firstDay = new Date(now.getFullYear(), 0, 1)
        const lastDay = new Date(now.getFullYear(), 11, 31)
        this.formsearch.DtFinal = lastDay
        this.formsearch.DtInicial = firstDay
        this.showDate = false
      }

      if (obj.target.id === 'personalizado') {
        this.showDate = true
      }

      let id = obj.target.id
      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.getElementById(id).classList.toggle('btn-periodos')
      document.getElementById(id).classList.toggle('btn-periodos-active')
    },
    getAllEnteprise () {
      RequestsRepository.GetAllEnterprisesByApprovedRequest()
        .then(Response => {
          this.dataEnteprise = Response.data.data
        })
        .catch(Error => console.log(Error))

      ProposalRepository.GetCredenciadaByNameProposta()
        .then(Response => {
          this.imobiliaria = Response.data.data
        })
        .catch(() => {})
    },
    Search () {
      this.formsearch.ImobiliariaId = this.formsearch.imobiliaria.value
      this.onlyTable = false
      if (this.formsearch.empreendimentoId !== '' || this.formsearch.ImobiliariaId !== null) {
        this.onlyTable = true
      }
      if (this.typeSearch === 'semanal' || this.typeSearch === 'mensal') {
        this.onlyTable = true
      }
      this.setCustomDate((this.typeSearch === 'personalizado'))
      this.setSearch(this.onlyTable)
      this.$emit('search', this.formsearch)
      localStoreHelper.relatorio.vendasCredenciadas(this.formsearch)
    },
    setSearch (newValue) {
      this.$emit('setSearch', newValue)
    },
    setCustomDate (newValue) {
      this.$emit('setCustomDate', newValue)
    },
    Clear () {
      localStoreHelper.relatorio.vendasCredenciadas(null)
      this.$refs.ImobliariaVendasTypeahead.clear()
      Object.keys(this.formsearch).forEach(props => {
        if (props === 'imobiliaria') {
          this.formsearch[props].value = ''
        } else {
          this.formsearch[props] = ''
        }
      })

      document.querySelectorAll('.btn-periodos-active').forEach((element) => {
        element.classList.remove('btn-periodos-active')
        element.classList.add('btn-periodos')
      })
      document.querySelector('#anual').classList.add('btn-periodos-active')
      document.querySelector('#anual').classList.remove('btn-periodos')

      const now = new Date()
      const firstDay = new Date(now.getFullYear(), 0, 1)
      const lastDay = new Date(now.getFullYear(), 11, 31)
      this.formsearch.DtFinal = lastDay
      this.formsearch.DtInicial = firstDay

      this.setCustomDate(false)
      this.setSearch(false)
      this.$emit('search', this.formsearch)
      this.showDate = false
      this.formsearch.filterweek = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesbyaccredited/components/searchsalesbyaccredited/searchsalesbyaccredited.js